module.exports = __webpack_public_path__ + "img/espace-reserve.05e8611c.png";